<div class="formation-section">
  <div class="formation-content">
    <ags-fiche-formation-entete [infoFormation]="infoFormation" [modalite]="modalite"> </ags-fiche-formation-entete>
    <ags-fiche-formation-focus [infoFormation]="infoFormation" [modalite]="modalite"></ags-fiche-formation-focus>
    <div class="detail-content">
      <ags-fiche-formation-detail [infoFormation]="infoFormation" [modalite]="modalite"></ags-fiche-formation-detail>
    </div>
  </div>
</div>
